<div class="row g-0 justify-content-between align-items-center">
    <div class="col-auto">
        <div class="row g-0 align-items-center">
            <div class="col-auto">
                <q-ss-header-logo [appName]="app"></q-ss-header-logo>
            </div>

            <div
                *ngIf="showEnvironment"
                class="col-auto badge bg-light text-dark app-environment"
            >
                {{ environment | uppercase }}
            </div>
        </div>
    </div>

    <div class="col-auto">
        <ul class="list-inline ul-styling mb-0">
            <li class="list-inline-item">
                <q-dropdown-popup
                    [list]="apps | async"
                    [align]="'right'"
                    [itemTemplate]="appItems"
                >
                    <span
                        class="qb-sprite qb-sprite-apps"
                        title="Application Selector"
                    ></span>
                    <ng-template #appItems let-app>
                        <a
                            *ngIf="app?.url"
                            class="q-popup-item q-popup-item-link app-link"
                            href="{{ app.url }}"
                        >
                            <img
                                *ngIf="app?.iconSmall"
                                src="{{ app.iconSmall }}"
                                width="18"
                            />
                            <span>{{ app.name }}</span>
                        </a>
                    </ng-template>
                </q-dropdown-popup>
            </li>
            <li class="list-inline-item">
                <q-dropdown-popup
                    [list]="userMenu"
                    [align]="'right'"
                    (itemClick)="onItemClick($event)"
                >
                    <span
                        class="qb-sprite qb-sprite-user"
                        title="{{ userName }}"
                    ></span>
                </q-dropdown-popup>
            </li>
        </ul>
    </div>
</div>

<div class="alert-layout">
    <q-alert-detail></q-alert-detail>
</div>
